module.exports = __webpack_public_path__ + "media/images/Learnhub-logo-cacfe8e92b1b5eb7c020a5edd1cc4345.svg";